type SocialProofSectionProps = {
  quotes: Array<{ quote: string; attribution: string }>;
  badges: string[];
};

export function SocialProofSection({ quotes, badges }: SocialProofSectionProps) {
  return (
    <section className="bg-slate-950 py-24" aria-labelledby="social-proof-heading">
      <div className="mx-auto max-w-6xl px-6">
        <h2 id="social-proof-heading" className="text-3xl font-semibold text-white sm:text-4xl">
          Trusted by mission-critical teams
        </h2>
        <div className="mt-12 grid gap-8 lg:grid-cols-2">
          {quotes.map((item) => (
            <figure
              key={item.quote}
              className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100"
            >
              <blockquote className="text-lg font-medium text-white">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-sm text-slate-300">
                {item.attribution}
              </figcaption>
            </figure>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-slate-300">
          {badges.map((badge) => (
            <span
              key={badge}
              className="rounded-full border border-white/10 bg-white/5 px-5 py-2"
            >
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
